import * as _ from 'underscore'

import { Enums } from "../common/enums"

import { ICopyable, IOpChangeState, IReferenceType } from "../util/interfaces"
import { OpTransmissionType } from "../core"
import { OpPacketStatus } from "./op-packet-status"
import { OpPacketHistory } from "./op-packet-history"
import { OpTransmissionDriver } from './op-transmission-driver'
import { OpPacketDataArch } from './op-packet-data-arch'

export class OpPacket implements IOpChangeState, IReferenceType, ICopyable<OpPacket> {

    //#region Properties

    public idPacket: number
    public serialNbr: number
    public address: string
    public idTransmissionDriver: number
    public isIncoming: boolean
    public idTransmissionType: number
    public transmittedPackets: number
    public bytes: number
    public transmittedBytes: number
    public body: number[]

    //#endregion


    //#region Navigation properties

    public transmissionDriver: OpTransmissionDriver
    public transmissionType: OpTransmissionType

    //#endregion

    //#region Custom properties

    public get lastUpdate(): Date {
        if (_.size(this.packetHistory) === 0) {
            return null
        } else {
            return _.max(this.packetHistory, (packHistory: OpPacketHistory) => packHistory.idPacket).time
        }
    }
    public get packetStatus(): OpPacketStatus {
        if (_.size(this.packetHistory) === 0) {
            return null
        } else {
            return _.max(this.packetHistory, (packHistory: OpPacketHistory) => packHistory.idPacket).packetStatus
        }
    }
    public packetHistory: OpPacketHistory[]
    public packetData: OpPacketDataArch[]

    public opState: Enums.OpChangeState
    //#endregion


    //#region Ctor

    constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    //#endregion


    //#region IReferenceType implementation

    public getReferenceType(): Enums.ReferenceType {
        return Enums.ReferenceType.IdPacket
    }
    public getReferenceKey(): number {
        return this.idPacket
    }
    public getReferenceValue(): any {
        return this
    }

    //#endregion 

    public toString(): string {
        return this.address
    }


    //#region IJsonSerializer Implementation

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj != null) {
            this.idPacket = opObj.ID_PACKET
            this.serialNbr = opObj.SERIAL_NBR
            this.address = opObj.ADDRESS
            this.idTransmissionDriver = opObj.ID_TRANSMISSION_DRIVER
            this.isIncoming = opObj.IS_INCOMING
            this.idTransmissionType = opObj.ID_TRANSMISSION_TYPE
            this.transmittedPackets = opObj.TRANSMITTED_PACKETS
            this.bytes = opObj.BYTES
            this.transmittedBytes = opObj.TRANSMITTED_BYTES
            this.body = opObj.BODY

            this.packetHistory = (_.size(opObj.PacketHistory) > 0) ? _.map(opObj.PacketHistory, (packHistory: any) => new OpPacketHistory(packHistory)) : null
            this.packetData = (_.size(opObj.PacketData) > 0) ? _.map(opObj.PacketData, (packData: any) => new OpPacketDataArch(packData)) : null

            this.transmissionDriver = (opObj._TransmissionDriver != null) ? new OpTransmissionDriver(opObj._TransmissionDriver) : null
            this.transmissionType = (opObj._TransmissionType != null) ? new OpTransmissionType(opObj._TransmissionType) : null
            this.opState = opObj.OpState
        }
    }

    public toJSON(compressed: boolean = false): any {
        return {

            ID_PACKET: this.idPacket,
            SERIAL_NBR: this.serialNbr,
            ADDRESS: this.address,
            ID_TRANSMISSION_DRIVER: this.idTransmissionDriver,
            IS_INCOMING: this.isIncoming,
            ID_TRANSMISSION_TYPE: this.idTransmissionType,
            TRANSMITTED_PACKETS: this.transmittedPackets,
            BYTES: this.bytes,
            TRANSMITTED_BYTES: this.transmittedBytes,
            BODY: this.body,


        }
    }

    //#endregion

    //#region ICopyable Implementation

    public clone(includeNavigationProperties: boolean = false, includeCustomProperties: boolean = false, includeDataList: boolean = false, includeDynamicValues: boolean = false): OpPacket {
        const newPacket: OpPacket = new OpPacket(null)

        newPacket.copy(this, includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues)

        return newPacket
    }

    public copy(source: OpPacket, includeNavigationProperties: boolean = false, includeCustomProperties: boolean = false, includeDataList: boolean = false, includeDynamicValues: boolean = false): void {
        if (source == null) {
            return
        }

        if (includeNavigationProperties) {
            if (source.transmissionDriver != null) {
                const newTransmissionDriver: OpTransmissionDriver = new OpTransmissionDriver(null)
                newTransmissionDriver.copy(source.transmissionDriver, true, true, true, true)
                this.transmissionDriver = newTransmissionDriver
            }

        }

        if (includeCustomProperties) {
            if (_.size(source.packetHistory) > 0) {
                this.packetHistory = _.map(source.packetHistory, (history: OpPacketHistory) => {
                    const pHistory: OpPacketHistory = new OpPacketHistory(null)
                    pHistory.copy(history, true, true, true, true)
                    return pHistory
                })
            }

            if (_.size(source.packetData) > 0) {
                this.packetData = _.map(source.packetData, (data: OpPacketDataArch) => {
                    const pData: OpPacketDataArch = new OpPacketDataArch(null)
                    pData.copy(data, true, true, true, true)
                    return pData
                })
            }
        }

        if (includeDataList) {
            //no dataList
        }

        if (includeDynamicValues) {
            //no dynamic values
        }

        this.idPacket = source.idPacket
        this.serialNbr = source.serialNbr
        this.address = source.address
        this.idTransmissionDriver = source.idTransmissionDriver
        this.isIncoming = source.isIncoming
        this.idTransmissionType = source.idTransmissionType
        this.transmittedPackets = source.transmittedPackets
        this.bytes = source.bytes
        this.transmittedBytes = source.transmittedBytes
        this.body = source.body

        this.opState = source.opState
    }

    //#endregion
}